import { render } from "./BaseReport.vue?vue&type=template&id=6da59b12"
import script from "./BaseReport.vue?vue&type=script&lang=js"
export * from "./BaseReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__